import { AssociateProductType } from "./types"
import type { AssociateProductTypeOption } from "./types"

import { AssosiatedProductType, EquivalencyType } from "@/graphql/codegen/graphql"

export enum FilterField {
  EquivalentTypes = "equivalentTypes",
  ProductStatuses = "productStatuses",
  AssociationTypes = "associationTypes",
}

export const PRODUCT_TYPE_OPTIONS: AssociateProductTypeOption[] = [
  { value: AssociateProductType.Akrochem, label: "Akrochem Product" },
  { value: AssociateProductType.Competitor, label: "Competitor Product" },
]

export const EQUIVALENCY_TYPE_LABELS: Record<EquivalencyType, string> = {
  [EquivalencyType.Chemical]: "Chemical",
  [EquivalencyType.Functional]: "Functional",
}

export const EQUIVALENCY_TYPE_COLORS: Record<EquivalencyType, string> = {
  [EquivalencyType.Chemical]: "bg-tertiary-yellow-300",
  [EquivalencyType.Functional]: "bg-gray-300",
}

export const ASSOCIATION_TYPE_LABELS: Record<AssosiatedProductType, string> = {
  [AssosiatedProductType.Akrochem]: "Akrochem",
  [AssosiatedProductType.Competitor]: "Competitor",
  [AssosiatedProductType.NonAssosiated]: "Non Associated",
}
